// @flow

// Effect Manager
import { fork, call } from 'redux-saga/effects'

// Sagas
import watchUploadOperations from './operations'

// Controller
import controller from 'hfty-ctrl-import-jobs-tool'

export default function *main (): Generator<*, void, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchUploadOperations)
}
